import React, {Component} from 'react';
import LoginStore from "../../../stores/LoginStore";
import {withKeycloak} from '@react-keycloak/web';


class UserAccount extends Component {

    constructor(props){
        super(props);
        this.onLogoutClick = this.onLogoutClick.bind(this);
    }

    onLogoutClick = () => {
        this.props.keycloak.logout();
    }

    getUserName=()=>{
        let keycloakInstance=this.props.keycloak;
        return keycloakInstance?.tokenParsed?.name
    }

    render() {
        const userFullName=this.getUserName()
        return (
            <li className="dropdown user user-menu">
                <a href="" className="dropdown-toggle" data-toggle="dropdown">
                    <span style={{ fontSize: '18px' }}>{userFullName}</span>
                </a>
                <ul className="dropdown-menu scale-up">
                    <a href="#" onClick={this.onLogoutClick}>
                        <li>
                            <div className="row">
                                <div className="col-12 text-left">
                                    <i className="fa fa-power-off" /> Logout
                                </div>
                            </div>
                        </li>
                    </a>
                </ul>
            </li>
        );
    }
}

export default withKeycloak(UserAccount);
